import { useRef, useState } from 'react'
import { rolesTranslations } from '../../services/data'
import { rolesColors } from '../../services/data'


export function SendInvite({ openRoles, sendInvite }) {
    const email = useRef()
    const [roles, setRoles] = useState({
        ideaMaker: false,
        thumbnailEditor: false,
        researcher: false,
        scripter: false,
        producer: false,
    })

    const handleToggle = (role) => {
        setRoles(prev => ({ ...prev, [role]: !prev[role] }))
    }

    const onSendInvite = async (ev) => {
        ev?.preventDefault()
        const didSend = await sendInvite(email.current.value, roles)
        if (typeof didSend === 'boolean' && didSend) {
            email.current.value = ''
            setRoles({
                ideaMaker: false,
                thumbnailEditor: false,
                researcher: false,
                scripter: false,
                producer: false,
            })
        }
    }

    return <form className='send-invite' onSubmit={onSendInvite}>
        <h3>אימייל</h3>
        <input
            style={{ marginBottom: '20px' }}
            type='email'
            ref={email}
            placeholder='example@gmail.com'
            required
        />

        <h3>תפקידים</h3>
        <div className="roles-checkboxes" style={{ marginBottom: '20px' }}>
            {Object.entries(roles).map(([role, checked]) => <label className='opt-wrapper' key={role}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => handleToggle(role)}
                />
                <p className={rolesColors[role] ? rolesColors[role] + '-text' : ''}>{rolesTranslations[role]}</p>
            </label>)}

        </div>

        <p onClick={openRoles} style={{ cursor: 'pointer' }}>
            <span className="material-symbols-outlined">info</span>
            מה כל תפקיד מורשה לעשות?
        </p>

        <button className='arise'>שלח הזמנה</button>
    </form>
}
